export default "__VITE_ASSET__BlQ7Pvvp__"